import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import * as S from './styles';
import { FaArrowsAltV } from 'react-icons/fa';
import { Spacer } from '../../../../../components/Spacer';

export function Item({ montagem, index, moveCard }) {
  const montagemRef = useRef(null);

  const [{ handlerId }, drop] = useDrop({
    accept: 'montagem',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!montagemRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = montagemRef.current?.getBoundingClientRect();

      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY * 0.5) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY * 1.5) {
        return;
      }
      moveCard(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'montagem',
    item: () => {
      return { Id: montagem.Id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(montagemRef));
  return (
    <S.Container ref={montagemRef} data-handler-id={handlerId}>
      <S.MontagemTitle>
        {index + 1}° {montagem?.DescricaoMontagem}
      </S.MontagemTitle>
      <Spacer x={20} />
      <FaArrowsAltV size={20} color="#fff" />
    </S.Container>
  );
}
